import React, { FunctionComponent } from "react";
import * as ReactDOM from "react-dom";
import "./portal.css";

export interface Props {}
export const Portal: FunctionComponent<Props> = ({ children }) => {
  const el = React.useMemo(() => document.createElement("div"), []);

  React.useEffect(() => {
    document.body.appendChild(el);
    return () => {
      document.body.removeChild(el);
    };
  }, [el]);

  return ReactDOM.createPortal(
    <>
      <div className="portal-mask"></div>
      {children}
    </>,
    el
  );
};

Portal.displayName = "Portal";
